@if (isMiseEnAvantVisible()) {
  <app-mise-en-avant
    [icon]="icon"
    [titre]="titre"
    [sousTitre]="sousTitre"
    [chips]="chips"
    [menu]="menuActions"
    [actionMenuDisabled]="isActionMenuDisabled()"
    [ngClass]="{'is-disabled': miseEnAvantDisabled}"
    @animationDropDown>
  </app-mise-en-avant>
}

@if (hasMenu360) {
  <app-view360 [pageContent]="content"
    [titre]="domaine" [hideRetour]="getHideRetour">
    <ng-container menuItems>
      @for (page of sortedMenus; track page) {
        @if (isMenu360Visible(page)) {
          <div class="view360_nav-element">
            <a [ngClass]="{'is-active': isMenuSelected(page)}" (click)="actionMenu360item(page)" href="">
              <ejs-tooltip [content]="page.caption" position="RightCenter">
                <span></span>
              </ejs-tooltip>
              {{page.caption}}
            </a>
          </div>
        }
      }
    </ng-container>
  </app-view360>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}


<ng-template #content>
  <app-page-body
    [titre]="selectedMenuTitle"
    [hasBackground]="!hasMenu360 && enteteSimple"
    [hasRetour]="afficherBoutonRetourEnTete()"
    [boutonRetourSansFondBlanc]="boutonRetourSansFondBlanc"
    (retour)="traiterClicRetourEnTete()"
    [isHeaderVisible]="isHeaderVisible">
    <ng-container pageContent>
      <ng-content select="[content]"></ng-content>
    </ng-container>
    <ng-container headerRight>
    </ng-container>
  </app-page-body>
</ng-template>
